// @ts-expect-error
import MapView from '@arcgis/core/views/MapView';
// @ts-expect-error
import ArcGISMap from '@arcgis/core/Map';
// @ts-expect-error
import esriConfig from '@arcgis/core/config';
// @ts-expect-error
import Extent from '@arcgis/core/geometry/Extent';
// @ts-expect-error
import WebTileLayer from '@arcgis/core/layers/WebTileLayer';
import { getUrls } from './getUrls';
import { attachMapChrome } from './attachMapChrome';

export const MAX_ZOOM = 30;

export function initializeMap(
  ref: HTMLDivElement,
  setBaseLayer: React.Dispatch<React.SetStateAction<any>>,
) {
  // Absolute path is required: relative './assets' resolves against the current
  // URL (e.g. /login/housing -> /login/assets/...), which breaks ArcGIS workers
  // and prevents GeoJSON layers such as network/sections/geo from loading.
  esriConfig.assetsPath = '/assets';
  esriConfig.request.interceptors = [];
  esriConfig.request.interceptors.push({
    // set the `urls` property to the URL of the FeatureLayer so that this
    // interceptor only applies to requests made to the FeatureLayer URL
    urls: getUrls(),
    before: (params: any) => {
      params.requestOptions = {
        ...(params.requestOptions || {}),
        headers: {
          ...((params.requestOptions && params.requestOptions.headers) || {}),
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      };
    },
  });
  var ext = new Extent({
    xmin: -197253.726104,
    ymin: 6903313.7840020005,
    xmax: -196852.49644,
    ymax: 6903741.440501,
    spatialReference: {
      wkid: 3857,
    },
  });

  var wmsLayer = new WebTileLayer({
    // spatialReference: spatRef,
    name: 'StadiaMaps',
    title: 'StadiaMaps',
    urlTemplate: `https://tiles.stadiamaps.com/tiles/outdoors/{z}/{x}/{y}{r}.png?api_key=${process.env.REACT_APP_STADIA_MAPS_API_KEY}`,
    visible: true,
  });

  const map = new ArcGISMap({
    layers: [wmsLayer],
  });

  const view = new MapView({
    container: ref,
    map: map,
    center: ext.center, // Longitude, latitude
    zoom: 5,
    extent: ext,
    slider: false,
    navigation: {
      actionMap: {
        mouseWheel: 'zoom',
      },
    },
    popupEnabled: false,
  });

  // Dedicated style for WFS point highlights (Image Viewer) so it is distinct
  // from the default survey highlight style used elsewhere.
  view.highlights.add({
    name: 'wfs-point-highlight',
    color: [255, 0, 255],
    haloOpacity: 1,
    fillOpacity: 0.35,
  } as any);

  // Dimmed survey polyline highlight — used when a WFS point is also highlighted.
  view.highlights.add({
    name: 'survey-highlight-dimmed',
    color: [0, 255, 255],
    haloOpacity: 0.6,
    fillOpacity: 0.2,
  } as any);

  view.ui.components = [];
  view.popupEnabled = false;
  
  void attachMapChrome(view).catch((error: unknown) => {
    console.error('Failed to attach ArcGIS map chrome (scale bar / zoom)', error);
  });

  //Constrain the max and min zoom levels
  view.constraints = {
    minZoom: 2,
    maxZoom: MAX_ZOOM,
  };

  if (typeof view.resize !== 'function') {
    view.resize = () => {};
  }

  setBaseLayer(wmsLayer);

  return view;
}
